
// @ts-nocheck


export const localeCodes =  [
  "fr-FR"
]

export const localeLoaders = {
  "fr-FR": [{ key: "../src/locales/fr-FR.json", load: () => import("../src/locales/fr-FR.json" /* webpackChunkName: "locale__app_src_locales_fr_FR_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "src/locales/locale.detector.ts",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "fr-FR",
      "dir": "ltr",
      "flag": "fr",
      "iso": "fr-FR",
      "name": "French",
      "files": [
        "locales/fr-FR.json"
      ]
    }
  ],
  "defaultLocale": "fr-FR",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "./locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": [
    {
      "langDir": "/app/node_modules/nuxt-zod-i18n/dist/runtime/locales",
      "locales": []
    }
  ]
}

export const normalizedLocales = [
  {
    "code": "fr-FR",
    "dir": "ltr",
    "flag": "fr",
    "iso": "fr-FR",
    "name": "French",
    "files": [
      {
        "path": "locales/fr-FR.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
